export const DROPDOWN_OPEN = 'DROPDOWN_OPEN';
export const dropdownOpen = (dropdownOpen) => ({
  type: DROPDOWN_OPEN,
  payload: {
    dropdownOpen,
  },
});
export const DROPDOWN_OPEN_FAVORITOS = 'DROPDOWN_OPEN_FAVORITOS';
export const dropdownOpenFavoritos = (dropdownOpenFavoritos) => ({
  type: DROPDOWN_OPEN_FAVORITOS,
  payload: {
    dropdownOpenFavoritos,
  },
});
export const DROPDOWN_OPEN_ORDENACAO = 'DROPDOWN_OPEN_ORDENACAO';
export const dropdownOpenOrdenacao = (dropdownOpenOrdenacao) => ({
  type: DROPDOWN_OPEN_ORDENACAO,
  payload: {
    dropdownOpenOrdenacao,
  },
});
export const INPUT_VAZIO = 'INPUT_VAZIO';
export const inputVazio = (inputVazio) => ({
  type: INPUT_VAZIO,
  payload: {
    inputVazio,
  },
});

export const LABEL_FILTRO_SELECIONADO = 'LABEL_FILTRO_SELECIONADO';
export const labelFiltroSelecionado = (labelFiltroSelecionado) => ({
  type: LABEL_FILTRO_SELECIONADO,
  payload: {
    labelFiltroSelecionado,
  },
});

export const LABEL_FILTRO_STATUS_SELECIONADO = 'LABEL_FILTRO_STATUS_SELECIONADO';
export const labelFiltroStatusSelecionado = (labelFiltroStatusSelecionado) => ({
  type: LABEL_FILTRO_STATUS_SELECIONADO,
  payload: {
    labelFiltroStatusSelecionado,
  },
});

export const ID_FILTRO_SELECIONADO = 'ID_FILTRO_SELECIONADO';
export const idFiltroSelecionado = (idFiltroSelecionado) => ({
  type: ID_FILTRO_SELECIONADO,
  payload: {
    idFiltroSelecionado,
  },
});

export const TIPO_FILTRO_SELECIONADO = 'TIPO_FILTRO_SELECIONADO';
export const tipoFiltroSelecionado = (tipoFiltroSelecionado) => ({
  type: TIPO_FILTRO_SELECIONADO,
  payload: {
    tipoFiltroSelecionado,
  },
});

export const OPTIONS_FILTRO_INPUT_TYPE_SELECT = 'OPTIONS_FILTRO_INPUT_TYPE_SELECT';
export const optionsFiltroInputTypeSelect = (optionsFiltroInputTypeSelect) => ({
  type: OPTIONS_FILTRO_INPUT_TYPE_SELECT,
  payload: {
    optionsFiltroInputTypeSelect,
  },
});

export const LABEL_FAVORITO_SELECIONADO = 'LABEL_FAVORITO_SELECIONADO';
export const labelFavoritoSelecionado = (labelFavoritoSelecionado) => ({
  type: LABEL_FAVORITO_SELECIONADO,
  payload: {
    labelFavoritoSelecionado,
  },
});

export const LABEL_ORDENACAO_SELECIONADO = 'LABEL_ORDENACAO_SELECIONADO';
export const labelOrdenacaoSelecionado = (labelOrdenacaoSelecionado) => ({
  type: LABEL_ORDENACAO_SELECIONADO,
  payload: {
    labelOrdenacaoSelecionado,
  },
});

export const TITULO_NOVO_FILTRO_FAVORITO = 'TITULO_NOVO_FILTRO_FAVORITO';
export const tituloNovoFiltroFavorito = (tituloNovoFiltroFavorito) => ({
  type: TITULO_NOVO_FILTRO_FAVORITO,
  payload: {
    tituloNovoFiltroFavorito,
  },
});

export const NOVO_FILTRO_FAVORITO_IS_DEFAULT = 'NOVO_FILTRO_FAVORITO_IS_DEFAULT';
export const novoFiltroFavoritoIsDefault = (novoFiltroFavoritoIsDefault) => ({
  type: NOVO_FILTRO_FAVORITO_IS_DEFAULT,
  payload: {
    novoFiltroFavoritoIsDefault,
  },
});

export const SHOW_MODAL_FAVORITO = 'SHOW_MODAL_FAVORITO';
export const showModalFavoritos = (showModalFavoritos) => ({
  type: SHOW_MODAL_FAVORITO,
  payload: {
    showModalFavoritos,
  },
});

export const VALOR_FILTRO = 'VALOR_FILTRO';
export const valorFiltro = (valorFiltro) => ({
  type: VALOR_FILTRO,
  payload: {
    valorFiltro,
  },
});

export const ETAPA_FILTRO = 'ETAPA_FILTRO';
export const etapaFiltro = (etapaFiltro) => ({
  type: ETAPA_FILTRO,
  payload: {
    etapaFiltro,
  },
});

export const FILTROS = 'FILTROS';
export const filtros = (filtros) => ({
  type: FILTROS,
  payload: {
    filtros,
  },
});

export const FAVORITOS = 'FAVORITOS';
export const favoritos = (favoritos) => ({
  type: FAVORITOS,
  payload: {
    favoritos,
  },
});

export const FILTROS_SELECIONADOS = 'FILTROS_SELECIONADOS';
export const filtrosSelecionados = (filtrosSelecionados) => ({
  type: FILTROS_SELECIONADOS,
  payload: {
    filtrosSelecionados,
  },
});

export const PERIODO_DE = 'PERIODO_DE';
export const periodoDe = (periodoDe) => ({
  type: PERIODO_DE,
  payload: {
    periodoDe,
  },
});

export const PERIODO_ATE = 'PERIODO_ATE';
export const periodoAte = (periodoAte) => ({
  type: PERIODO_ATE,
  payload: {
    periodoAte,
  },
});

export const ORDENACAO = 'ORDENACAO';
export const ordenacao = (ordenacao) => ({
  type: ORDENACAO,
  payload: {
    ordenacao,
  },
});

export const SENTIDO_ORDENACAO_ASC = 'SENTIDO_ORDENACAO_ASC';
export const sentidoOrdenacaoASC = (sentidoOrdenacaoASC) => ({
  type: SENTIDO_ORDENACAO_ASC,
  payload: {
    sentidoOrdenacaoASC,
  },
});

export const DROPDOWN_OPEN_GRUPO_USUARIO = 'DROPDOWN_OPEN_GRUPO_USUARIO';
export const dropdownOpenGrupoUsuario = (dropdownOpenGrupoUsuario) => ({
  type: DROPDOWN_OPEN_GRUPO_USUARIO,
  payload: {
    dropdownOpenGrupoUsuario,
  },
});

export const GRUPO_USUARIOS = 'GRUPO_USUARIOS';
export const grupoUsuarios = (grupoUsuarios) => ({
  type: GRUPO_USUARIOS,
  payload: {
    grupoUsuarios,
  },
});

export const LABEL_GRUPOS_USUARIOS = 'LABEL_GRUPOS_USUARIOS';
export const labelGruposUsuario = (labelGruposUsuario) => ({
  type: LABEL_GRUPOS_USUARIOS,
  payload: {
    labelGruposUsuario,
  },
});

export const ID_GRUPO_USUARIOS = 'ID_GRUPO_USUARIOS';
export const idGrupoUsuario = (idGrupoUsuario) => ({
  type: ID_GRUPO_USUARIOS,
  payload: {
    idGrupoUsuario,
  },
});

export const STATUS_ETAPA_SELECIONADA = 'STATUS_ETAPA_SELECIONADA';
export const statusEtapaSelecionada = (statusEtapaSelecionada) => ({
  type: STATUS_ETAPA_SELECIONADA,
  payload: {
    statusEtapaSelecionada,
  },
});

export const DROPDOWN_OPEN_FILTER_LINKED = 'DROPDOWN_OPEN_FILTER_LINKED';
export const dropdownOpenFilterLinked = (dropdownOpenFilterLinked) => ({
  type: DROPDOWN_OPEN_FILTER_LINKED,
  payload: {
    dropdownOpenFilterLinked,
  },
});

export const LABEL_FILTER_LINKED = 'LABEL_FILTER_LINKED';
export const labelFilterLinked = (labelFilterLinked) => ({
  type: LABEL_FILTER_LINKED,
  payload: {
    labelFilterLinked,
  }
})

export const DATA_NASCIMENTO = 'DATA_NASCIMENTO';
export const dataNascimento = (dataNascimento) => ({
  type: DATA_NASCIMENTO,
  payload: {
    dataNascimento,
  },
});


// WEBPACK FOOTER //
// ./src/pages/main/filtros/filtro.action.js